import { nexcareVersion } from '../config/serviceConfig';
import Get from '../services/Get';

/** 
 * @param {{ csList: string, callStatus: string, csActive: string, date: { start_date: string, end_date: string }}|null} filter
 */
const getListCallHistory = (page = 1, limit = 10, searchBy = '', keyword = '', filter = null, order = '', token) => {
    let filterQuery = ''

    if (filter) {
        if (filter.csList) {
            filterQuery += `&listCS=${filter.csList}`
        }
        if (filter.callStatus) {
            filterQuery += `&callStatus=${filter.callStatus}`
        }
        if (filter.csActive) {
            filterQuery += `&csActive=${filter.csActive}`
        }
        if (filter.date) {
            if (filter.date.start_date && filter.date.end_date) {
                filterQuery += `&start_date=${filter.date.start_date}&end_date=${filter.date.end_date}`
            }
        }
    }

    return Get(`/${nexcareVersion}/nexcare/call-logging?page=${page}&limit=${limit}&searchBy=${searchBy}&keyword=${keyword}${filterQuery}&order=${order}`, token)
}

/** 
 * @param {{ csList: string, callStatus: string, csActive: string, date: { start_date: string, end_date: string }}|null} filter
 */
const getInitiateCallHistory = (searchBy = '', keyword = '', filter = null, token) => {
    let filterQuery = ''

    if (filter) {
        if (filter.csList) {
            filterQuery += `&listCS=${filter.csList}`
        }
        if (filter.callStatus) {
            filterQuery += `&callStatus=${filter.callStatus}`
        }
        if (filter.csActive) {
            filterQuery += `&csActive=${filter.csActive}`
        }
        if (filter.date) {
            if (filter.date.start_date && filter.date.end_date) {
                filterQuery += `&start_date=${filter.date.start_date}&end_date=${filter.date.end_date}`
            }
        }
    }

    return Get(`/${nexcareVersion}/nexcare/call-logging/initiate?searchBy=${searchBy}&keyword=${keyword}${filterQuery}`, token)
}

/** 
 * @param {{ name: string }|null} filter
 */
const getListUserCS = (page, limit, csActive = '', filter = null, token) => {
    let filterParam = ''
    if (filter) {
        if (filter.name) {
            filterParam += `alias_name like ${filter.name}`
        }
    }

    return Get(`/${nexcareVersion}/nexcare/call-logging/user-cs?page=${page}&limit=${limit}&csActive=${csActive}&filter=${filterParam}&order=alias_name asc`, token)
}

const API_CALL_HISTORY = {
    getListCallHistory,
    getInitiateCallHistory,
    getListUserCS
}

export default API_CALL_HISTORY